<div
	*ngIf="student"
	class="student-item"
	(mouseenter)="hovered.emit(true)"
	(mouseleave)="hovered.emit(false)"
	[ngClass]="{ 'disable-bg-hover': disableBGHover }">
	<div class="student-tag">
		<span *ngIf="ordered" class="order-indicator">
			{{ index + 1 | position }}
		</span>
		<div
			*ngIf="student.profile_picture; else defaultProfilePicture"
			[ngStyle]="{ background: 'url(' + student.profile_picture + ') no-repeat left center/cover' }"
			class="profile-picture"></div>
		<ng-template #defaultProfilePicture>
			<img class="profile-picture" src="../../../../../assets/Avatar Default.svg" alt="Avatar" />
		</ng-template>
		<div (click)="homePageService.goToStudentPage(student.id)">
			<span class="name">{{ student.display_name }}</span>
		</div>
		<div *ngIf="groups && groups.length > 0 && !kioskMode" class="tw-animate-fadein-300 tw-w-5 tw-h-5 tw-ml-2">
			<bp-icon icon="feature-encounter-prevention" customToolTip [contentTemplate]="tooltip" [toolTipHideDelay]="300"></bp-icon>
		</div>
	</div>
	<div class="student-item-right-side">
		<ng-content select="[sp-student-list-item-right]"></ng-content>
	</div>
</div>
<ng-template #tooltip>
	<app-encounter-prevention-tooltip [user]="user" [groups]="groups"></app-encounter-prevention-tooltip>
</ng-template>
